import { render, staticRenderFns } from "./Chapter5_3.vue?vue&type=template&id=3e8d0839&scoped=true&"
import script from "./Chapter5_3.vue?vue&type=script&lang=js&"
export * from "./Chapter5_3.vue?vue&type=script&lang=js&"
import style0 from "./Chapter5_3.vue?vue&type=style&index=0&id=3e8d0839&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8d0839",
  null
  
)

export default component.exports